import { useSelector } from 'react-redux';

import { selectCurrentAddons, selectDroppedAddOns } from '@app/redux';

import { GetCurrentAddOnsPayload } from '@mfe/shared/schema-types';

export const useHasCarryOverAddons = (): {
  hasCarryOverAddons: boolean;
  carryOverAddons: GetCurrentAddOnsPayload[];
} => {
  const currentAddOns = useSelector(selectCurrentAddons);
  const droppedAddons = useSelector(selectDroppedAddOns);

  const droppedProductTypeIds = new Set(droppedAddons.map((addOn) => addOn.productTypeId));

  const carryOverAddons = currentAddOns.filter((addOn) => !droppedProductTypeIds.has(addOn.productTypeId));
  const hasCarryOverAddons = carryOverAddons.length > 0;

  return { hasCarryOverAddons, carryOverAddons };
};
